import { Navigate, Outlet } from 'react-router-dom';

import CircularProgress from '@mui/material/CircularProgress';

import { useAuth } from './AuthContext';

export const RoutesAdmin = () => {
    const { auth, claims, loading } = useAuth();

    if (loading) {
        return <CircularProgress />;
    }

    if (auth.currentUser && !claims.admin) {
        return <Navigate to="/dashboard" replace />;
    }

    if (!auth.currentUser) {
        return <Navigate to="/login" />;
    }

    return <Outlet />;
};